module.exports = __webpack_public_path__ + "static/circle-stamp-710f084ec86902c30786fe10726b2ef0.png";